import type {ListServicesSearchInput} from "./list-services.schema";

import {keepPreviousData, useQuery} from "@tanstack/react-query";

import {listServicesQueryOptions} from "./list-services.query-options";

export function useListServices(search: ListServicesSearchInput) {
  return useQuery({...listServicesQueryOptions(search), placeholderData: keepPreviousData});
}
